<template>
<div class="noscrolldiv">
    <div class="resourcebar">
        <!-- Create the actual resource groups -->
        <ul>
        <li v-for="(resourceGroup, index) in this.$store.state.ResourceGroups" :key="index"> <ResourceGroup :ref="resourceGroup.name" @endedDrag="endedDrag()" :color="resourceGroup.color" :name="resourceGroup.name" :resourceID="resourceGroup.id"/></li>
        </ul>
    </div>    
</div>
</template>

<script>
import ResourceGroup from './ResourceGroup'
export default {
    name: "ResourceBar",
    methods: {
        endedDrag(){
            this.$emit("endedDrag");
        },
    },
    props: {},
    components: {
        ResourceGroup
    }
}
</script>

<style scoped>
ul{
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
    height:100%;
    width:100%;

}
.noscrolldiv{
    overflow-y: auto;
    height: 100%;
    padding: 0;
    margin: 0;
    z-index: 10;
    width: var(--resource-bar-width);
}
li{
    min-height: var(--resource-group-height);
    height: calc(100% / 6);
    color: #e0e0e0;
    margin:4px;
    margin-right: 0px;

}
::-webkit-scrollbar {
  width: 0px;
}

.resourcebar{
width: var(--resource-bar-width);
height: 100%;

}
</style>